var React = require('react');
import { Box, Container, Grid } from '@mui/material';
import MUIDataTable from 'mui-datatables';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import MomentUtils from "@date-io/moment";
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import { MuiThemeProvider } from '@material-ui/core/styles';
import { muiThemeDesign } from '../../mui-theme-design';
import { muiThemePicker } from '../../mui-theme-design';
import EditSummaryDialog from '../EditDialogue/EditSummary';
import WeekPicker from "../../TimesheetItems/WeekPicker";
import DayDialog from "../../TimesheetItems/DayDialog";
import moment from "moment";
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import { makeStyles } from "@mui/styles";
import {logger, customBodyForExcelReport,handleExport,checkAuthentication,muiLoaderOptions,permissions} from '../../utils';
const ExcelJS = require('exceljs');
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import { red } from '@material-ui/core/colors';
import Tooltip from '@mui/material/Tooltip';
import LockIcon from '@mui/icons-material/Lock';
import LockOpenIcon from '@mui/icons-material/LockOpen';


const pageStyles = makeStyles(theme => ({
    root: {
        "& .MuiPaper-root": {
            overflowy: "hidden",
            boxShadow: '3'
        },
        "& .MuiPaper-rounded": {
            backgroundColor: "#1976d2",
            boxShadow: '3'
        },
        "& .MuiPaper-elevation1": {
            backgroundColor: "transparent",
            boxShadow: '3'
        },
        "& .Mui-checked": {
            color: '#1f1b1e'
        },
        "& .MuiButton-label": {
            color: "#1f1b1e"
        },
    },
    "& .MuiButtonBase-root": {
        backgroundColor: "#1976d2",
        boxShadow: '3'
    },
    "& .MuiButton-root": {
        backgroundColor: "#1976d2",
        boxShadow: '3'
    },
    tabs: {
        "& .MuiTabs-indicator": {
            display: "none"
        }
    },
    tabPanel: {
        "& .MuiBox-root": {
            paddingTop: {
            xs: 5,
            sm: 5,
            md: 5
            }
        },
    }  
}));

export default function SummaryTable() {
    const [refresh, setRefresh] = React.useState(true);
    const [week, setWeek] = React.useState(moment(new Date()).weekday(0));
    const [dataSet, setDataSet] = React.useState([{}]);
    const [permission, permissionSet] = React.useState([]);
    const [ignored, forceupdate] = React.useReducer(x => x + 1, 0);
    const [isLoading, setIsLoading] = React.useState(true);
    const [expand, setExpand] = React.useState(false);
    const classes = pageStyles();

// Updated to handle partial hours
    function sumDigits(str) {
        const numbers = str.split(',').map(parseFloat);
        const sum = numbers.reduce((acc, num) => acc + num, 0);
        return sum;
    }
    const [value, setValue] = React.useState(0);

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
    };

    const setData = (json) => {
        let choices = [];
        json.forEach(choice => choices.push({
            UserID: choice.UserID,
            Name: choice.FirstName + ' ' + choice.LastName,
            Week: moment.utc(choice.WeekOf).format("MM/DD/YYYY"),
            Monday: choice.Monday == null ? 0 : sumDigits(choice.Monday).toFixed(2),
            MondayIsLocked: choice.MondayIsLocked,
            Tuesday: choice.Tuesday == null ? 0 : sumDigits(choice.Tuesday).toFixed(2),
            TuesdayIsLocked: choice.TuesdayIsLocked,
            Wednesday: choice.Wednesday == null ? 0 : sumDigits(choice.Wednesday).toFixed(2),
            WednesdayIsLocked: choice.WednesdayIsLocked,
            Thursday: choice.Thursday == null ? 0 : sumDigits(choice.Thursday).toFixed(2),
            ThursdayIsLocked: choice.ThursdayIsLocked,
            Friday: choice.Friday == null ? 0 : sumDigits(choice.Friday).toFixed(2),
            FridayIsLocked: choice.FridayIsLocked,
            Saturday: choice.Saturday == null ? 0 : sumDigits(choice.Saturday).toFixed(2),
            SaturdayIsLocked: choice.SaturdayIsLocked,
            Sunday: choice.Sunday == null ? 0 : sumDigits(choice.Sunday).toFixed(2),
            SundayIsLocked: choice.SundayIsLocked,
            Total: choice.Total.toFixed(2),
            PTO_Holiday: choice.PTO_Holiday.toFixed(2),
            TotalNT: choice.TotalNT,
            TotalOT: choice.TotalOT,
            TotalWND: choice.TotalWND,
            TotalHOL: choice.TotalHOL,
            Assigned: choice.Assigned,
            Status: choice.VerifyStatus
        }))
        setDataSet(choices)
    };

    const handleDialogCallback = (childData) => {

        var TimeEntry = [];
        var weekOf = moment(week);


        TimeEntry.push({
            "UserID": childData.UserID,
            "RoleID": childData.RoleID,
            "TaskID": childData.TaskID,
            "WeekOf": moment(weekOf._d).format("YYYY-MM-DD"), // This is a possible bug, the "_d" field is internal and not supposed to be used.
            "DayOf": childData.DayOf,
            "Hours": childData.Hours,
            "isFlaged": 0,
            "FlagType": childData.TimeType
        })

        logger(TimeEntry);
        fetch("api/Time_Entry", {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                "time_entry": TimeEntry,
                "time_entry_prop": childData.propList
            })
        })
        setRefresh(true)
        logger(childData);
    };

    const handleEditCallback = (childData) => {
        fetch("/api/Summary", {
            method: 'PATCH',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                "ApprovalAll": childData.approvalAll,
                "Week": childData.Week
            })
        })
        
        logger(childData)
     //   window.location.reload();
        setRefresh(true)
    };

    const callRefresh = () => {
        setRefresh(true)
    };


    const handleWeekCallback = (childData) => {
        setWeek(childData.format('YYYY-MM-DD'));
    //    window.location.reload();
        setRefresh(true)
    };

    const columns = [
        {
            name: "Actions",
            options: {
                filter: false,
                sort: false,
                empty: true,
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    return (
                        <div>
                            {logger(dataSet[dataIndex])}
                            {dataSet[dataIndex].Week !== moment.utc(null).format("MM/DD/YYYY") ? <EditSummaryDialog key={rowIndex}
                                callRefresh={callRefresh}
                                handleEditCallback={handleEditCallback}
                                permission={permission}
                                data={{ Name: dataSet[dataIndex].Name, UserID: dataSet[dataIndex].UserID, WeekOf: dataSet[dataIndex].Week }} /> : "No Time Entered"}
                        </div>
                    );
                }
            }
        },
        {
            name: "Name",
            label: "Name",
            options: {
                filter: true,
                sort: true,
            }
        },
         {
            name: "Assigned",
             label: "Lead",
             options: {
                 filter: true,
                 sort: true,
                 display: false,
            }
        },
        {
            name: "Monday",
           label: `Mon ${moment(week).format('MM/DD')}`, 
       
            options: {
                filter: false,
                sort: false,
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    const isLocked = dataSet[dataIndex].MondayIsLocked;
                    return (
                        <Tooltip title={isLocked == 1 ? "All Time Entries Submitted" : isLocked == 0 ? "Not all Time Entries Submitted" : ""} placement="top-end">
                            <div>
                                {isLocked != null && (isLocked ? <LockIcon sx={{ verticalAlign: "text-bottom" }}/> : <LockOpenIcon sx={{ verticalAlign: "text-bottom" }}/>)}
                                {`${dataSet[dataIndex].Monday}`}
                            </div>
                        </Tooltip>
                    );		
                }
            }
        },
        {
            name: "Tuesday",
            label: `Tue ${moment(week).add(1, 'days').format('MM/DD')}`,
            options: {
                filter: false,
                sort: false,
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    const isLocked = dataSet[dataIndex].TuesdayIsLocked;
                    return (
                        <Tooltip title={isLocked == 1 ? "All Time Entries Submitted" : isLocked == 0 ? "Not all Time Entries Submitted" : ""} placement="top-end">
                            <div>
                                {isLocked != null && (isLocked ? <LockIcon sx={{ verticalAlign: "text-bottom" }}/> : <LockOpenIcon sx={{ verticalAlign: "text-bottom" }}/>)}
                                {`${dataSet[dataIndex].Tuesday}`}
                            </div>
                        </Tooltip>
                    );		
                }
            }
        },
        {
            name: "Wednesday",
            label: `Wed ${moment(week).add(2, 'days').format('MM/DD')}`,
            options: {
                filter: false,
                sort: false,
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    const isLocked = dataSet[dataIndex].WednesdayIsLocked;
                    return (
                        <Tooltip title={isLocked == 1 ? "All Time Entries Submitted" : isLocked == 0 ? "Not all Time Entries Submitted" : ""} placement="top-end">
                            <div>
                                {isLocked != null && (isLocked ? <LockIcon sx={{ verticalAlign: "text-bottom" }}/> : <LockOpenIcon sx={{ verticalAlign: "text-bottom" }}/>)}
                                {`${dataSet[dataIndex].Wednesday}`}
                            </div>
                        </Tooltip>
                    );		
                }
            }
        },
        {
            name: "Thursday",
            label: `Thu ${moment(week).add(3, 'days').format('MM/DD')}`,
            options: {
                filter: false,
                sort: false,
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    const isLocked = dataSet[dataIndex].ThursdayIsLocked;
                    return (
                        <Tooltip title={isLocked == 1 ? "All Time Entries Submitted" : isLocked == 0 ? "Not all Time Entries Submitted" : ""} placement="top-end">
                            <div>
                                {isLocked != null && (isLocked ? <LockIcon sx={{ verticalAlign: "text-bottom" }}/> : <LockOpenIcon sx={{ verticalAlign: "text-bottom" }}/>)}
                                {`${dataSet[dataIndex].Thursday}`}
                            </div>
                        </Tooltip>
                    );		
                }
            }
        },
        {
            name: "Friday",
            label: `Fri ${moment(week).add(4, 'days').format('MM/DD')}`,
            options: {
                filter: false,
                sort: false,
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    const isLocked = dataSet[dataIndex].FridayIsLocked;
                    return (
                        <Tooltip title={isLocked == 1 ? "All Time Entries Submitted" : isLocked == 0 ? "Not all Time Entries Submitted" : ""} placement="top-end">
                            <div>
                                {isLocked != null && (isLocked ? <LockIcon sx={{ verticalAlign: "text-bottom" }}/> : <LockOpenIcon sx={{ verticalAlign: "text-bottom" }}/>)}
                                {`${dataSet[dataIndex].Friday}`}
                            </div>
                        </Tooltip>
                    );		
                }
            }
        },
        {
            name: "Saturday",
            label: `Sat ${moment(week).add(5, 'days').format('MM/DD')}`,
            options: {
                filter: false,
                sort: false,
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    const isLocked = dataSet[dataIndex].SaturdayIsLocked;
                    return (
                        <Tooltip title={isLocked == 1 ? "All Time Entries Submitted" : isLocked == 0 ? "Not all Time Entries Submitted" : ""} placement="top-end">
                            <div>
                                {isLocked != null && (isLocked ? <LockIcon sx={{ verticalAlign: "text-bottom" }}/> : <LockOpenIcon sx={{ verticalAlign: "text-bottom" }}/>)}
                                {`${dataSet[dataIndex].Saturday}`}
                            </div>
                        </Tooltip>
                    );		
                }
            }
        },
        {
            name: "Sunday",
            label: `Sun ${moment(week).add(6, 'days').format('MM/DD')}`,
            options: {
                filter: false,
                sort: false,
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    const isLocked = dataSet[dataIndex].SundayIsLocked;
                    return (
                        <Tooltip title={isLocked == 1 ? "All Time Entries Submitted" : isLocked == 0 ? "Not all Time Entries Submitted" : ""} placement="top-end">
                            <div>
                                {isLocked != null && (isLocked ? <LockIcon sx={{ verticalAlign: "text-bottom" }}/> : <LockOpenIcon sx={{ verticalAlign: "text-bottom" }}/>)}
                                {`${dataSet[dataIndex].Sunday}`}
                            </div>
                        </Tooltip>
                    );		
                }
            }
        },
        {
            name: "Total",
            label: "Total (NT/OT/WND/HOL)",
            options: {
                filter: false,
                sort: false,
                empty: true,
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    const invalidHours = Number(dataSet[dataIndex].TotalNT) > 40 || Number(dataSet[dataIndex].TotalNT) != 40 && Number(dataSet[dataIndex].TotalOT) > 0;
                    return (
                        <Tooltip title={invalidHours ? `NT/OT is invalid`: ""} placement="top-end">
                            <div style={invalidHours ? { color: "red" } : {}}>
                                {`${dataSet[dataIndex].Total}(${dataSet[dataIndex].TotalNT}/${dataSet[dataIndex].TotalOT}/${dataSet[dataIndex].TotalWND}/${dataSet[dataIndex].TotalHOL})`}
                            </div>
                        </Tooltip>
                    );		
                }
            }
        },
        {
            name: "PTO_Holiday",
            label: "PTO/Holiday",
            options: {
                filter: false,
                sort: false,
            }
        },
        {
            name: "Status",
            options: {
                filter: false,
                sort: false,
                empty: true,
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    const invalidHours = Number(dataSet[dataIndex].TotalNT) > 40 || Number(dataSet[dataIndex].TotalNT) != 40 && Number(dataSet[dataIndex].TotalOT) > 0;
                    const isPending = `${dataSet[dataIndex].Status}`.includes('-1') || `${dataSet[dataIndex].Status}`.includes('0');
                    return (
                        <div style={invalidHours ? { color: "red" } : isPending ? {} : { color: "green" }}>
                            {isPending ? 'Pending' : 'Approved'}
                        </div>
                    );
                }
            }
        }
    ];
    const Item = styled(Paper)(({ theme }) => ({
        textAlign: 'center',
        backgroundColor: '#1976d2',
        boxShadow: '3',
        "& .MuiPaper-elevation1": {
             backgroundColor: "transparent",
            boxShadow: '3'          
        },
        "& .MuiPaper-root": {
            backgroundColor: "transparent",
            boxShadow: '3'
        },
        "& .MuiPaper-rounded": {
            backgroundColor: "#1976d2",
            boxShadow: '3'
        },
         "& .MuiButtonBase-root": {
            backgroundColor: "#1976d2",
             boxShadow: '3'
        },         
          "& .MuiButton-root": {
            backgroundColor: "#1976d2",
              boxShadow: '3'
        },
        "& .MuiButton-label": {
            color: "#1976d2",
        },
        "& .Typography-label": {
            h4: {
                color: "#ffffff !important"
            },
            h2: {
                color: "#ffffff !important"
            },
        },
    }));

    const getSavedRowsPerPage = () => {
        const savedValue = localStorage.getItem('SummaryrowsPerPage');
        return savedValue ? parseInt(savedValue) : 100; // Default value
    }
    // Save to local storage
    const saveRowsPerPage = (value) => {
        localStorage.setItem('SummaryrowsPerPage', value.toString());
    }

    const initialRowsPerPage = getSavedRowsPerPage();

    const options = {
        filter: true,
        filterType: 'dropdown',
        responsive: 'vertical',
        rowsPerPage: initialRowsPerPage,
        rowsPerPageOptions: [10, 20, 50, 100],
        selectableRows: 'none',textLabels: {
			toolbar: {
			  search: "Search",
			  downloadCsv: "Download Excel", 
			  print: "Print",
			  viewColumns: "View Columns",
			  filterTable: "Filter Table",
				},
		},
		 onDownload: (buildHead, buildBody, columns, data) => {
			// Custom buildHead and buildBody functions
			const customBuildHead = () => {
				var newColumns = columns.map(column => column.label);
				return newColumns;
			}
		
			const customBuildBody = () => {
				const headers = customBuildHead();
				return customBodyForExcelReport({data:data, headers:headers, columnIndexToRemove:0});
			};
			
			const headers = customBuildHead();
			const rows = customBuildBody();
			//handleExport(rows, headers);
			handleExport({rows:rows, headers:headers, filename:'Summary.xlsx', columnIndexToRemove:0})
			return false;
		},
        customToolbar: () => (
            <div>
                <MuiPickersUtilsProvider utils={MomentUtils} locale="en">
                   
                        <Grid container spacing={2} justifyContent="flex-end">                          
                        <Grid item xs={2}>  <MuiThemeProvider theme={muiThemePicker}> <WeekPicker handleWeekCallback={handleWeekCallback} week={week} /></MuiThemeProvider></Grid>
                        <Grid item xs={7}> <FormControlLabel
                            name="Expand"
                            label="Expand"
                            style={{ color: 'white' }}
                            control={
                                <Tooltip title="indirect subordinates">
                                <Checkbox
                                checked={expand}
                                labelStyle={{ color: 'white' }}
                                iconStyle={{ fill: 'white' }}
                                inputStyle={{ color: 'white' }}
                                style={{ color: 'white' }}
                                onChange={e => {
                                    setExpand(!expand)
                                    setRefresh(true)
                                }} />
                                </Tooltip>  
                                    }
                        /> </Grid>
                        <Grid item xs={3} justifyContent="flex-start">  <DayDialog handleDialogCallback={handleDialogCallback} week={moment(week).format('YYYY-MM-DD')} /></Grid>
                        </Grid>
                </MuiPickersUtilsProvider>
            </div>
        )
    };
    React.useEffect(() => {
		if (open){
		checkAuthentication();
		}
        if (refresh) {
            logger(week)
            fetch(`/api/User/Permission`)
                .then(res => res.json())
                .then(json => permissionSet(json))
               // permissionSet(permissions);
            
            fetch(`/api/Summary/${moment(week).format('YYYY-MM-DD')}/${expand}`)
                .then(res => res.json())
                .then(json => {
					setData(json);
					setIsLoading(false);
				})
            setRefresh(false);
        }

    }, [refresh])

    options.onChangeRowsPerPage = (newRowsPerPage) => {
        saveRowsPerPage(newRowsPerPage);
    };

    return (
        <MuiThemeProvider theme={muiThemeDesign}>
            <Box sx={{ paddingTop: { xs: 0, sm: 0, md: 0, lg: 0, xl: 0 } }}
           //     className={classes.tabPanel}
            >
                    <Grid container rowSpacing={1} columnSpacing={1}>
                        <Grid item xs={12}>
                            <MUIDataTable 
                                title={
                                    <Typography variant="h6" style={{ color: "white" }}>
                                        Time Summary
                                    </Typography>
                                }
                                data={isLoading ? [] :dataSet}
                                columns={columns}
                                options={muiLoaderOptions(options, isLoading)}
                            />
                        </Grid>
                    </Grid>                       
            </Box>
        </MuiThemeProvider> 
    );
}